import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import commonFn from "@/commons/commonFunction";
class MerchantTransactionControlTransactionAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "merchanttransactioncontrolreporttransactions";
  /**
   * @override
   * Created by: pvtruong 18/10/2022
   */
  getList(payload) {
    let param = {
      skipCount: payload.skip || 0,
      maxResultCount: payload.take || 20,
      sorting: payload.Sort || null,
      filter: payload.Filter || null,
      ignoreSummary: payload.ignoreSummary || false,
    };

    let url = this.getAPIUrl() + "/list";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }
}

export default new MerchantTransactionControlTransactionAPI();
